module.exports = __webpack_public_path__ + "img/clock.ea3f87d1.svg";